import {Button, DialogContent, Stack, Typography} from '@mui/material';
import React from 'react';

import {translations} from 'presentation/translations-new';
import {IconIllustration} from '../IconIllustration';
import {Modal} from '../Modal';
import {AlertModalProps} from './types';

const {close} = translations['pt-br'].commons;

function AlertModal({
	subDescription,
	footerContent,
	footerProps,
	headerTitle,
	description,
	variant,
	title,
	customIconName,
	onClose,
	preWrap,
	showIcon = true,
	customContentStyles,
	buttonLabel,
	buttonDataTagId,
	closeBtnDataTagId,
	disableClose,
	padding,
	headerDataTagId,
	...modalRootProps
}: AlertModalProps) {
	return (
		<Modal.Root onClose={onClose} {...modalRootProps}>
			<Modal.Header
				title={headerTitle}
				onClose={onClose}
				modalDataTagId={headerDataTagId}
				closeBtnDataTagId={closeBtnDataTagId}
				disableClose={disableClose}
			/>
			<DialogContent sx={{p: 'initial'}}>
				<Stack alignItems="center" gap={2} padding={padding ?? 3} {...customContentStyles}>
					{showIcon ? (
						<IconIllustration variant={variant} customIconName={customIconName} />
					) : null}
					{title ? (
						<Typography variant="h6" textAlign="center">
							{title}
						</Typography>
					) : null}
					{description ? (
						<Typography
							whiteSpace={preWrap ? 'pre-wrap' : 'normal'}
							variant="body1"
							textAlign="center">
							{description}
						</Typography>
					) : null}
					{subDescription}
				</Stack>
			</DialogContent>

			<Modal.Footer {...footerProps}>
				{footerContent || (
					<Button
						onClick={onClose}
						variant="contained"
						size="large"
						fullWidth
						data-tag-id={buttonDataTagId}>
						{buttonLabel || close}
					</Button>
				)}
			</Modal.Footer>
		</Modal.Root>
	);
}

export {AlertModal};
